import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrderPageRequest = {};
var _createOrderPageResponse = {};
var _currentSubscriptionInfo = { periodEndDate: 'google.protobuf.Timestamp' };
var _getProductInfoRequest = {};
var _getProductInfoResponse = {};
var _getUserOfferingRequest = {};
var _getUserOfferingResponse = {
    offerValidUntil: 'google.protobuf.Timestamp',
    currentSubscriptionInfo: '_currentSubscriptionInfo',
};
var _validateNoPreviousPurchaseRequest = {};
var _validateNoPreviousPurchaseResponse = {};
function resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-store',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/pricing',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/studio/pricing',
                destPath: '/upgradeWebsite',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-store',
                destPath: '',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/store/plans/premiumStatus',
                destPath: '/api/plans/premiumStatus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a user offering for the given product type. If you also specify a
 * `productFamilyId` only products that belong to this family are included in the
 * user offering. You can limit the returned products by providing additional
 * `customOfferingFilters`.
 *
 *
 * A user offering consists of all products that the customer can purchase,
 * including billing cycle durations, features, and relevant pricing details.
 * Note that the currency rate remains fixed. That means, if you set a
 * product's price at 100 USD with an initial EUR exchange rate of 1.05 USD,
 * the price for European customers is always 105 EUR. This won't change even
 * if the EUR-USD exchange rate fluctuates.
 *
 * In case you haven’t integrated with the
 * [Dealer](https://wix-marketing.wixanswers.com/en/article/dealer-faqs), the
 * endpoint returns all `PUBLISHED` products of the given product type. Then,
 * you may need to add your own filtering before populating the purchase
 * funnel pages. This is especially important, if you add products to a
 * specific product type after its initial setup.
 *
 * The response includes `displayProperties` for the product type, the
 * products, and the features. But they're limited to the fields listed in the
 * `translatable` parameter of the relevant
 * [`displayAttributes` object](https://bo.wix.com/wix-docs/rest/drafts/premium-display-manager/display-attributes/display-attributes-object).
 */
export function getUserOffering(payload) {
    var _a = serializer(_getUserOfferingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserOfferingResponse, {
        _currentSubscriptionInfo: _currentSubscriptionInfo,
    }).fromJSON;
    function __getUserOffering(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.GetUserOffering',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/offering/{productTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserOffering.fromReq = fromReq;
    return __getUserOffering;
}
getUserOffering.__isAmbassador = true;
/**
 * Retrieves pricing and display information for the specified product.
 *
 *
 * The response of the Get Product Info call includes details about
 * the product's pricing and
 * [display attributes](https://bo.wix.com/wix-docs/rest/drafts/premium-display-manager/display-attributes/display-attributes-object).
 * In contrast, calling the
 * [Get Product endpoint](https://bo.wix.com/wix-docs/rest/drafts/premium-product-catalog-v2/products/get-product)
 * of the Premium Product Catalog V2 API doesn’t return pricing and display
 * details, but instead information about coupons and vouchers that are
 * associated with the product.
 */
export function getProductInfo(payload) {
    var _a = serializer(_getProductInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProductInfoResponse, {}).fromJSON;
    function __getProductInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.GetProductInfo',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/productInfo/{productId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProductInfo.fromReq = fromReq;
    return __getProductInfo;
}
getProductInfo.__isAmbassador = true;
/**
 * Generates the `orderSessionId` and `riskIframeUrl` for an order page that contains
 * the specified products.
 *
 *
 * After calling this endpoint, you need to forward the response to the
 * client’s URL so that the customer is able to see the order page.
 */
export function createOrderPage(payload) {
    var _a = serializer(_createOrderPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderPageResponse, {}).fromJSON;
    function __createOrderPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.CreateOrderPage',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/createOrderPage',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrderPage.fromReq = fromReq;
    return __createOrderPage;
}
createOrderPage.__isAmbassador = true;
/**
 * Checks that the customer hasn’t purchased the same product during the
 * last 2 days. This helps prevent unintentional double purchases.
 */
export function validateNoPreviousPurchase(payload) {
    var _a = serializer(_validateNoPreviousPurchaseRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateNoPreviousPurchaseResponse, {}).fromJSON;
    function __validateNoPreviousPurchase(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.ValidateNoPreviousPurchase',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/ValidateNoPreviousPurchase',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateNoPreviousPurchase.fromReq = fromReq;
    return __validateNoPreviousPurchase;
}
validateNoPreviousPurchase.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map